module.exports = __webpack_public_path__ + "static/media/content-5.22900cfc.svg";